import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const SET_CAMPAIGN_CONFIG   = "SET_CAMPAIGN_CONFIG";
const SET_ERROR_RESPONSE   = "SET_ERROR_RESPONSE";
const SET_APP_LOADED        = "SET_APP_LOADED";
const SET_APP_LOADING       = "SET_APP_LOADING";
const SET_CAMPAIGN_API_VARS = "SET_CAMPAIGN_API_VARS";
const SET_SCREEN            = "SET_SCREEN";
const SET_COUNT             = "SET_COUNT";
const SET_UNIT              = "SET_UNIT";
const SET_VOUCHERS_AMOUNT = "SET_VOUCHERS_AMOUNT";


export default new Vuex.Store({
	state: {

		app_loaded:false,
		app_loading:false,
		campaign_api_vars:false,
		screen:'welcome',
		count:30,
		error_response:false,
		unit:false,
		campaign_config:{
			background_colour : "",
			background_image  : "",
			background_repeat : "",
			background_size   : "",
			button_bg_colour  : "",
			button_colour     : "",
			font_family       : "",
			font_header_colour: "",
			font_header_size  : 18,
			font_normal_colour: "",
			font_normal_size  : 14,
			is_external_font  : "",
			logo_image        : "",
			logo_image_url    : "",
			spinner_class     : "",
			campaign_image    : "",
			campaign_image_url: "",
			voucher_intro     : "",
			voucher_text      : "",
			contact_vouchers_amount : 0
		}

	},
	mutations: {

		[SET_CAMPAIGN_CONFIG](state, value){
			state.campaign_config = value;
		},

		[SET_VOUCHERS_AMOUNT](state, value) {
			state.campaign_config.contact_vouchers_amount = value;
		},

		[SET_ERROR_RESPONSE](state, value){
			state.error_response = value;
		},

		[SET_APP_LOADED](state, value){
			state.app_loaded = value;
		},

		[SET_APP_LOADING](state, value){
			state.app_loading = value;
		},

		[SET_CAMPAIGN_API_VARS](state, value){
			state.campaign_api_vars = value;
		},

		[SET_SCREEN](state, value){
			state.screen = value;
		},

		[SET_COUNT](state, value){
			state.count = value;
		},

		[SET_UNIT](state, value){
			state.unit = value;
		},

	},
	actions: {

	},
	getters: {
		getCamapignConfig: state => {
			return state.campaign_config
		},

		getAppLoaded: state => {
			return state.app_loaded
		},

		getAppLoading: state => {
			return state.app_loading
		},

		getCampaignApiVars: state => {
			return state.campaign_api_vars
		},

		getScreen: state => {
			return state.screen
		},

		getCount: state => {
			return state.count
		},

		getErrorResponse: state => {
			return state.error_response
		},

		getUnit: state => {
			return state.unit
		},
	}
})
